import styled from '@emotion/styled';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';import { CloseIcon } from 'src/ui/assets/icons/other/CloseIcon';
import { withConfig } from 'src/withConfig';

export const SelectionWrapper = styled('ul', { label: 'SelectionWrapper' })`
    padding: 8px 0 0 0;
`;

export const LoginWrapper = styled('li', { label: 'LoginWrapper' })`
    margin-top: 15px;
`;

interface QuickBetContainerType {
    isVisible: boolean;
}

export const QuickBetContainer = withConfig(theme => styled('div', { label: 'QuickBetContainer' })<QuickBetContainerType>`
    inset: auto 0 0;
    opacity: ${({ isVisible }): number => isVisible ? 1 : 0};
    position: fixed;
    transform: translateY(${({ isVisible }): string => isVisible ? '0%' : '100%'});
    transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
    z-index: ${theme.star.zIndexGlobal.footer};
`);

export const QuickBetWrapper = withConfig(theme => styled('div', { label: 'QuickBetWrapper' })`
    background-color: ${theme.star.betslipGeneral.bgColor};
    border-bottom: 1px solid transparent;
    margin: auto;
    max-width: 414px;
    padding: 0 8px;
    position: relative;
    z-index: ${theme.star.zIndexGlobal.above};
`);

export const QuickBetSuccessWrapper = withConfig(theme => styled('div', { label: 'QuickBetSuccessWrapper' })`
    display: flex;
    align-items: center;
    background-color: ${theme.star.statuses.success.bgColor};
    color: ${theme.star.betslipGeneral.txtColor};
    padding: 16px;
    font-size: ${theme.star.fontSize.small};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${theme.star.zIndexGlobal.highLevel};
`);

export const CheckMarkWrapper = styled(CheckSingleIcon, { label: 'CheckMarkWrapper' })`
    fill: currentcolor;
    margin-right: 10px;
    width: 16px;
`;

export const QuickBetHeader = withConfig(theme => styled('h3', { label: 'QuickBetHeader' })`
    background-color: ${theme.star.betslipGeneral.bgColorTertiary};
    color: ${theme.star.betslipGeneral.txtColor};
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4;
    margin: 0 -8px;
    height: 48px;
    padding: 10px 8px;
    position: relative;
    text-transform: uppercase;
`);

export const QuickBetCloseButton = styled(CloseIcon, { label: 'QuickBetCloseButton' })`
    cursor: pointer;
    inset: 0 0 0 auto;
    padding: 12px;
    position: absolute;
    width: 48px;
`;

export const QuickBetErrorsAndWarningsWrapper = withConfig(theme => styled('div', { label: 'QuickBetErrorsAndWarningsWrapper' })`
    color: ${theme.star.betslipGeneral.txtColor};
`);
